import {Component, Inject, OnInit} from '@angular/core';
import {UtilsService} from "../../shared/utils.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SafetyObservationsViewUsersFilters} from "./safety-observations-view-users-filter.interface";

@Component({
  selector: 'app-safety-observations-view-users-filter',
  templateUrl: './safety-observations-view-users-filter.component.html',
  styleUrls: ['./safety-observations-view-users-filter.component.scss']
})
export class SafetyObservationsViewUsersFilterComponent implements OnInit {
  filters: SafetyObservationsViewUsersFilters = {
    trade: '',
    trades: []
  } as SafetyObservationsViewUsersFilters;

  constructor(
    private utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SafetyObservationsViewUsersFilterComponent>
  ) { }

  ngOnInit(): void {
    // Get Job Titles
    this.getTrades();

    this.filters.trade = this.data['trade'];
  }

  private async getTrades() {
    this.filters.trades = await this.utils.getTrades();
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.trade = '';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      trade: this.filters.trade
    }

    this.dialogRef.close(response);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
